import { render } from "./deposit.vue?vue&type=template&id=1569dd71&scoped=true"
import script from "./deposit.vue?vue&type=script&lang=js"
export * from "./deposit.vue?vue&type=script&lang=js"

import "./deposit.vue?vue&type=style&index=0&id=1569dd71&lang=scss&scoped=true"
import "./deposit.vue?vue&type=style&index=1&id=1569dd71&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1569dd71"]])

export default __exports__